/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from './vuetify'
import router from '../router'

// Sentry privacy hooks, used by main.ts
export { hasSensitiveQuery, scrubBreadcrumb, scrubDeep } from './sentryScrub'

// Types
import type { App } from 'vue'

export function registerPlugins (app: App) {
  app
    .use(vuetify)
    .use(router)
}
